// extracted by mini-css-extract-plugin
export var closeButton = "_gh-1";
export var closeX = "_gh-3";
export var container = "_gh-0";
export var image = "_gh-2";